import { getPollingQueueId } from 'utils/streaming/polling/queue';

import type { IHttpConfig } from '../../httpClient.model';

export default (config: IHttpConfig): IHttpConfig => {
  return {
    ...config,
    headers: {
      ...config.headers,
      'polling-queue-id': getPollingQueueId(),
    },
  };
};
